<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>

                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>نام</label>
                                    <input type="text" name="firstname" v-model="info.firstname"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>نام خانوادگی</label>
                                    <input type="text" name="lastname" v-model="info.lastname"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>شماره موبایل</label>
                                    <input type="text" name="phone" v-model="info.phone" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>ایمیل</label>
                                    <input type="text" name="email" v-model="info.email" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4 my-1">
                                <div class="form-group">
                                    <label>کد ملی</label>
                                    <input type="text" name="national_code" v-model="info.national_code"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4 my-1">
                                <div class="form-group ">
                                    <label>رمز عبور</label>
                                    <input type="password" name="password" v-model="info.password"
                                        class="form-control" />
                                </div>
                            </div>
                            <hr class="mt-5">
                            <div class="col-md-4 my-2">
                                <div class="form-group ">
                                    <label>نوع کاربری</label>
                                    <select v-model="info.type" name="type" class="form-control" id="">
                                        <option value="admin">ادمین</option>
                                        <option value="legal">حقوقی</option>
                                        <option value="real">حقیقی</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4 my-2">
                                <div class="form-group">
                                    <label>نقش </label>
                                    <select v-model="info.role_id" name="role_id" class="form-control" id="">
                                        <option value=""> انتخاب نقش</option>
                                        <option v-for="role in roles" :value="role.id">{{ role . name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                           
                            <div class="col-md-4 my-2">
                                <div class="form-group">
                                    <label>کاربر فعال باشد ؟ </label>
                                    <br>
                                    <a-switch v-model="info.status" value="1" name=status />
                                </div>


                            </div>
                            <hr class="mt-5">

                            <div class="col-md-4 ">
                                <div class="form-group ">
                                    <label for="">آپلود</label>
                                    <picture-input ref="pictureInput" width="300" height="200" margin="16"
                                        accept="image/jpeg,image/png" size="5" radius="5"
                                        :crop="false" :alertOnError="false" button-class="btn btn-success"
                                        @change="onChange(info.image)"
                                        :custom-strings="{
                                            upload: '<p>دستگاه شما از آپلود عکس پشتیبانی نمی کند</p>',
                                            drag: ' انتخاب عکس',
                                            tap: ' انتخاب عکس  ',
                                            change: 'تعویض عکس',
                                            remove: 'حذف عکس',
                                            select: 'انتخاب عکس',
                                            selected: '<p>عکس با موفقیت انتخاب شد</p>',
                                            fileSize: 'سایز فایل شما زیاد است',
                                            fileType: 'نوع فایل نا معتبر میباشد',
                                            aspect: 'Landscape/Portrait',
                                        }"
                                         id="image">
                                    </picture-input>
                                </div>

                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label style="margin-bottom:10px;">تاریخ تولد </label>
                                <date-picker v-model="info.birthday"></date-picker>

                              </div>
                            </div>
                        </div>
                        <div class="card-footer  ">
                            <div class="row ">
                                <div class="col-md-10"></div>
                                <div class="col-md-1 ">
                                    <button type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>
                                </div>
                               
                                <div class="col-md-1 ">
                                    <router-link to="/users/list" class="btn btn-fill btn-outline-danger w-100">بازگشت
                                    </router-link>
                                </div>

                            </div>

                        </div>
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    import PictureInput from 'vue-picture-input';
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
  
        components: {
            PictureInput,
            datePicker: VuePersianDatetimePicker

        },
        data() {
            return {
                info: {},
                roles: [],
            };
        },
        mounted() {
            let _this = this;
            axios
                .get('/roles/all')
                .then(function(response) {
                    _this.roles = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
        },
        methods: {
            onChange() {
                let _this = this;
                let formData = new FormData();
                formData.append("file", document.getElementById('image').files[0]);
                axios.post("/uploadImageUser", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }).then(function(response) {
                        _this.info.image = response.data.path;
                        _this.$toast.success("عکس کاربر با موفقیت ذخیره شد.   ");

                    })
                    .catch(function(err) {
                        _this.$toast.error("عکس ارسالی  صحیح  نیست.   ");
                        _this.$root.handleAxiosError(err);
                    });
            },

            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append("image", this.info.image);
                data.append("status", this.info.status == true ? '1' : '0');
                data.append("birthday", this.info.birthday);

                _this.$root.loading = true;
                axios
                    .post("/users/add", data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("کاربر با موفقیت ذخیره شد");
                        _this.$router.push("/users/list");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
